import BaseComponent from "../../components/BaseComponent";
import KlientsApi from "../../api/references/klients"
import SalePointsApi from "../../api/references/salePoints"
import BaseApi from "../../api/BaseApi"
import {
    Alert, Avatar,
    Button,
    ButtonGroup,
    Div,
    FormItem,
    FormLayout,
    Input, List,
    Panel,
    PanelHeader,
    PanelHeaderButton, RichCell, SimpleCell,
    SplitCol,
    SplitLayout, Switch, Title
} from "@vkontakte/vkui";
import {
    Icon20DeleteOutline,
    Icon20EditCircleFillBlue,
    Icon20ViewOutline,
    Icon24BrowserBack
} from "@vkontakte/icons";
import React from "react";

import {ACCESS_DENIED_MESSAGE, AdaptivityContext, EMPTY_INN, isTradeDesigner, userIsTradeChild} from "../../assets/constants";
import DadataKlientsSelectObject from "../Klients/dadataKlientsSelectObject";
import * as constants from "../../assets/constants";
import HelpButton from "../../assets/HelpButton";

import DadataKlientsSmartAutocomplete from "./dadataKlientsSmartAutocomplete";


class KlientsItem extends BaseComponent {


    state = {
        showDeleteSalePointAlert: false,
        error_klient: '',
        error_inn: '',
    }

    constructor() {
        super();
        this.innRef = React.createRef()
        this.titleRef = React.createRef()
        this.salePointsGalleryTimestamp = new Date().getTime(); // Timestamp для галереи торговых точек
    }

    componentDidMount() {
        super.componentDidMount();

        if (this.innRef.current) {
            this.innRef.current.setInputValue(this.props.item.INN)
        }
        if (this.titleRef.current) {
            this.titleRef.current.setInputValue(this.props.item.title)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.innRef.current) {
            this.innRef.current.setInputValue(this.props.item.INN)
        }
        if (this.titleRef.current) {
            this.titleRef.current.setInputValue(this.props.item.title)
        }

    }

    receiveMessage = (event) => {
        if (event.data == 'goGetBack') {
            this.cmdBack()
        }
    }

    render() {

        const {item} = this.props
        if (!item) return '!';
        const isDesigner = isTradeDesigner(this.props.current_user)
        const exclude = []
        if (item.childs && Array.isArray(item.childs)) {
            item.childs.map(el => exclude.push(el.INN))
        }

        exclude.push(item.INN)

        const exclude_str = exclude.join(',')

        const types = constants.getSalePointsTypes()

        const alertDeleteSalePoint = <Alert
            onClose={() => this.setState({showDeleteSalePointAlert: false})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {
                        if (isDesigner) {
                            window.postMessage({type: 'error', text: ACCESS_DENIED_MESSAGE, timeout: 3000})
                            this.setState({showDeleteSalePointAlert: false})
                            return
                        }
                        SalePointsApi.deleteSalePoint(this.state.delete_id).then(() => {
                            this.setState({showDeleteSalePointAlert: false})
                            window.postMessage({type: 'reloadCurrentKlient'})
                        })
                    },

                },
                {
                    title: 'Нет',
                    action: () => {

                        this.setState({showDeleteSalePointAlert: false})
                    },
                },
            ]}

            header="Удаление торговой точки"
            text={`Торговая точка будет удалена. Продолжить?`}
        />
        const images_url = this.props.base_url.replace("frontend/", '');
        return <SplitLayout popout={this.state.showDeleteSalePointAlert ? alertDeleteSalePoint : null}>
            <SplitCol>
                <PanelHeader style={{whiteSpace: "pre-line"}} before={

                    <PanelHeaderButton onClick={() => this.cmdBack()}


                                       key="cmd_back_klient_item"><Icon24BrowserBack/></PanelHeaderButton>}>

                    {item.id > 0 ? `Клиент ${item.title}` : 'Новый клиент'}
                </PanelHeader>
                <Panel>
                    <Div>
                        <FormLayout>
                            <DadataKlientsSmartAutocomplete
                                current_user={this.props.current_user}

                                style={{minHeight: '33px'}}

                                error={this.state.error_inn}

                                placeholder="Поиск по ИНН или наименованию клиента"
                                app="dadata"
                                act="suggestCompany"

                                default={item}
                                mode="outline"
                                size="s"
                                selectObject={this.setKlient}

                            />

                            <FormItem top="ИНН клиента" bottom={this.state.error_klient}
                                      status={this.state.error_klient ? 'error' : ''}>
                                <Input type="text" value={this.props.item.INN} onChange={this.handleINNChange}/>
                            </FormItem>
                            <SimpleCell Component="label" multiline style={{maxWidth: '250px'}}

                                        after={<Switch size={10} checked={item.is_unknown}
                                                       onChange={this.setIsUnknown}/>}>
                                Клиент не найден
                            </SimpleCell>
                            {false && <SimpleCell Component="label" multiline style={{maxWidth: '250px'}}
                                                  after={<Switch size={10} checked={item.is_main}
                                                                 disabled={item.parent_id != null}
                                                                 onChange={this.setIsMain}/>}>
                                Головной контрагент{item.parent_id ? <HelpButton
                                text="Контрагент уже назначен подчиненным, его нельзя сделать головным"/> : ''}
                            </SimpleCell>}

                            {item.is_main == 1 &&
                                <div>
                                    <Div>
                                        <DadataKlientsSelectObject style={{maxWidth: '360px'}}
                                                                   size="s"

                                                                   current_user={this.props.current_user}
                                                                   title=""
                                                                   params={`exclude_inns=${exclude_str}`}
                                                                   error={this.state.error_klient}
                                                                   modal_title="Список клиентов"
                                                                   unselect_title={'Добавить подчиненного клиента [+]'}
                                                                   clear_after_select
                                                                   selectObject={this.addChild}
                                                                   empty_rows_message="Пока ни чего не найдено. Уточните поиск по наименованию или ИНН"

                                        />
                                        <Title>Подчиненные клиенты</Title>
                                        {item.childs && <List>
                                            {item.childs.map(
                                                child =>
                                                    <RichCell subhead={child.INN} multiline
                                                              afterCaption={<div style={{
                                                                  display: "flex",
                                                                  flexDirection: "column"
                                                              }}>
                                                                  <Button mode="secondary" size="m"
                                                                          onClick={() => this.removeChild(child)}><Icon20DeleteOutline/></Button>
                                                              </div>
                                                              }
                                                    >

                                                        {child.title}
                                                    </RichCell>)}
                                        </List>}
                                    </Div>
                                </div>}
                            <div>
                                {item.id > 0 && <Div>
                                    <SplitLayout>
                                        <SplitCol width="100%">
                                            {!isDesigner && <FormItem top={this.props.title} bottom={this.props.error}
                                                                      status={this.props.error ? 'error' : 'valid'}>
                                                <Button style={{maxWidth: '360px'}} size="l"
                                                        onClick={() => this.addSalePoint()}>Добавить торговую точку
                                                    [+]</Button>
                                            </FormItem>}
                                        </SplitCol>
                                    </SplitLayout>

                                    <Title>Торговые точки</Title>
                                    {item.sale_points && <List>
                                        {item.sale_points.map(
                                            (point, index) => {
                                                let image_item = {
                                                    hasImage: false,
                                                    mainImage: images_url + constants.EMPTY_IMG,
                                                    thumb: images_url + constants.EMPTY_IMG
                                                }
                                                if (Array.isArray(point.images)) {
                                                    point.images.map((img) => {
                                                        if (img.hasImage && !image_item.hasImage) {
                                                            image_item = img
                                                            image_item.hasImage = true
                                                        }
                                                    })
                                                }
                                                const isTradeChild = !isDesigner && userIsTradeChild(this.props.current_user, point.user_id)
                                                return <RichCell
                                                    before={<a data-fancybox={'galleryIncomingDefective' + index}
                                                               href={(() => {
                                                                   const mainImageUrl = images_url + image_item.mainImage.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
                                                                   return mainImageUrl + (mainImageUrl.includes('?') ? '&t=' + this.salePointsGalleryTimestamp : '?t=' + this.salePointsGalleryTimestamp);
                                                               })()}>
                                                        {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                                 size={AdaptivityContext.isMobile ? 50 : 100}
                                                                 src={(() => {
                                                                     let thumbUrl = images_url +image_item.thumb.replace('https:/l', 'https://l').replace('https://lab.scladro.ru', '').replace(images_url, '');
                                                                     return thumbUrl + (thumbUrl.includes('?') ? '&t=' + this.salePointsGalleryTimestamp : '?t=' + this.salePointsGalleryTimestamp);
                                                                 })()}/>}
                                                    </a>}
                                                    subhead={`${point.mall ? point.mall.title + ', ' : ''}${point.full_address}`}
                                                    multiline
                                                    caption={
                                                        <div>
                                                            <div>Автор: <b>{point.author_name}</b></div>
                                                            <div>Ответственный: <b>{point.manager ? point.manager.title : 'Не указан'}</b>
                                                            </div>
                                                            <div>Изменено: {point.modified}</div>
                                                        </div>
                                                    }
                                                    afterCaption={<div style={{
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    }}>
                                                        <Button mode="secondary"
                                                                onClick={() => window.postMessage({
                                                                    type: 'setCurrentSalePoint',
                                                                    value: point
                                                                })}
                                                                size="s">{isTradeChild ?
                                                            <Icon20EditCircleFillBlue/> :
                                                            <Icon20ViewOutline/>}</Button>
                                                        {isTradeChild && <Button mode="secondary"
                                                                                 onClick={() => this.setState({
                                                                                     delete_id: point.id,
                                                                                     showDeleteSalePointAlert: true
                                                                                 })}
                                                                                 size="s"><Icon20DeleteOutline/></Button>}
                                                    </div>
                                                    }
                                                >

                                                    {types[point.type_]} {point.title}{point.trading_floor ? ', Зал: ' + point.trading_floor : ''}
                                                </RichCell>
                                            })}
                                    </List>}
                                </Div>}
                            </div>
                        </FormLayout>
                    </Div>
                    <Div className={AdaptivityContext.isMobile ? "action-board" : ''}>
                        <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>

                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.cmdBack()}>Отмена</Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.save()}>Сохранить</Button>
                        </ButtonGroup>
                    </Div>
                </Panel>
            </SplitCol>
        </SplitLayout>
    }

    handleINNChange = (e) => {
        const newINN = e.target.value
        const old = this.props.item
        old.INN = newINN
        window.postMessage({type: 'setCurrentKlient', value: old})
    }

    searchKlientByINN = async (inn) => {
        try {
            const sAjaxSource = '/?app=dadata&act=suggestCompany'
            const response = await BaseApi.post(sAjaxSource, {search: inn, page: 1, epp: 1})
            
            if (response.data.results && response.data.results.length > 0) {
                const result = response.data.results[0]
                // Формируем объект в том же формате, что ожидает setKlient
                const klientData = {
                    id: -1,
                    uid: result.data.inn,
                    title: result.value,
                    descr: result.data.inn,
                    data: result.data,
                    address: result.data.address ? (result.data.address.unrestricted_value ?? '') : ''
                }
                return klientData
            }
            return null
        } catch (error) {
            console.error('Ошибка поиска клиента по ИНН:', error)
            return null
        }
    }

    cmdBack = () => {

        if (this.props.hideForm()) {
            this.props.hideForm()
        }

        /*window.postMessage({
            type: 'setCurrentKlient',
            value: null
        })*/

    }
    setIsMain = (e) => {
        const old = this.props.item
        old.is_main = e.currentTarget.checked ? 1 : 0
        window.postMessage({type: 'setCurrentKlient', value: old})
    }
    setKlient = (e) => {
        const old = this.props.item
        old.id = e.id
        old.uid = e.uid
        old.title = e.title
        old.name = e.title
        old.INN = e.descr
        if (e.id && e.id > 0) {
            window.postMessage({type: 'setCurrentKlient', value: old})
        }
    }
    setIsUnknown = (e) => {
        const old = this.props.item
        old.is_unknown = e.currentTarget.checked ? 1 : 0
        if (old.is_unknown === 1) {
            old.title = ''
            old.INN = EMPTY_INN
        } else {
            old.title = ''
            old.INN = ''
        }
        window.postMessage({type: 'setCurrentKlient', value: old})
    }
    addChild = async (item) => {
        if (!item.id) {
            return
        }
        const old = this.props.item

        const new_item = {title: item.value, INN: item.data.inn}

        if (item.exist_id) {
            new_item.id = item.exist_id
            new_item.uid = item.exist_id
        } else {
            new_item.id = -1
            new_item.dadata_object = item
            const add_result = await KlientsApi.save(new_item)
            console.log(add_result)
            new_item.id = add_result.data.id
            new_item.uid = add_result.data.id
        }


        if (old.childs && Array.isArray(old.childs)) {
            old.childs = old.childs.filter(el => el.id != new_item.id)
        } else {
            old.childs = []
        }
        old.childs.push(new_item)
        window.postMessage({type: 'setCurrentKlient', value: old})
    }

    removeChild = (item) => {
        if (!item.id) {
            return
        }
        const old = this.props.item

        if (old.childs && Array.isArray(old.childs)) {
            old.childs = old.childs.filter(el => el.id != item.id)
        } else {
            old.childs = []
        }

        window.postMessage({type: 'setCurrentKlient', value: old})
    }

    addSalePoint = () => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({type: 'error', text: ACCESS_DENIED_MESSAGE, timeout: 3000})
            return
        }
        const {item} = this.props
        window.postMessage({
            type: 'setCurrentSalePoint', value:
                {
                    id: -1,
                    klient_id: this.props.item.id,
                    klient: item,
                    comment: '',
                    info: ''
                }
        })

    }
    save = async () => {

        let errors = 0

        this.setState({error_klient: '', error_inn: ''})
        const {item} = this.props

        if (!item.INN) {
            errors++
            this.setState({error_inn: 'Необходимо заполнить ИНН'})
        }
        if (!item.dadata_object && item.is_unknown !== 1) {
            // Если нет dadata_object и клиент не помечен как неизвестный, попытаемся найти по ИНН
            if (item.INN) {
                const foundKlient = await this.searchKlientByINN(item.INN)
                if (foundKlient) {
                    // Найден клиент, заполняем данные
                    this.setKlient(foundKlient)
                    // Добавляем dadata_object чтобы не было ошибки валидации
                    const updatedItem = this.props.item
                    updatedItem.dadata_object = foundKlient
                    window.postMessage({type: 'setCurrentKlient', value: updatedItem})
                } else {
                    errors++
                    this.setState({error_klient: 'Клиент с данным ИНН не найден. Выберите клиента из выпадающего списка или отметьте "Клиент не найден"'})
                }
            } else {
                errors++
                this.setState({error_klient: 'Необходимо выбрать клиента из выпадающего списка'})
            }
        }


        if (!item.title) {
            errors++
            this.setState({error_klient: 'Необходимо заполнить наименование'})
        }
        if (errors > 0) return

        if (!item.id || item.id == -1) {
            KlientsApi.checkINNExist(item.INN).then(result => {

                const {data} = result

                if (data.result && data.result.INN) {
                    this.setState({error_inn: 'Данный ИНН уже существует'})
                    return
                }

                this.doSave()


            })
        } else {
            this.doSave()
        }
    }

    doSave() {
        KlientsApi.save(this.props.item).then(result => {
            const {data} = result
            if (data.id) {
                window.postMessage('resetDefaultSelected')
                setTimeout(() => {
                    window.postMessage({type: 'setCurrentKlient', value: data})
                    window.postMessage({type: 'success', text: 'Данные сохранены', timeout: 1500, hideSpinner: true})
                    if (this.props.onCreate) {
                        this.props.onCreate(data)
                    }
                }, 600)
            }
        })
    }


}

export default KlientsItem